var React = require('react');

function DoubleCheck (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.6455 0L4.57224 8.19988L1.38079 4.94996L0 6.35001L4.57224 11L14.0263 1.40006L12.6455 0ZM8.69279 9.09432L10.5722 11L20.0263 1.40006L18.6455 0L10.5722 8.19988L10.0726 7.69324L8.69279 9.09432Z","fill":"#35008A"}));
}

DoubleCheck.defaultProps = {"width":"21","height":"11","viewBox":"0 0 21 11","fill":"none"};

module.exports = DoubleCheck;

DoubleCheck.default = DoubleCheck;
